var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.71645 10.8464C1.57793 10.7077 1.50009 10.5198 1.5 10.3238V1.75H10.0738C10.2698 1.75009 10.4577 1.82793 10.5964 1.96645L19.7834 11.1535C19.9221 11.2923 20 11.4804 20 11.6766C20 11.8727 19.9221 12.0609 19.7834 12.1997L11.9524 20.0334C11.8137 20.1721 11.6255 20.25 11.4293 20.25C11.2332 20.25 11.045 20.1721 10.9063 20.0334L1.71645 10.8464Z",
    fill: "#376486"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71645 10.8464C1.57793 10.7077 1.50009 10.5198 1.5 10.3238V1.75H10.0738C10.2698 1.75009 10.4577 1.82793 10.5964 1.96645L19.7834 11.1535C19.9221 11.2923 20 11.4804 20 11.6766C20 11.8727 19.9221 12.0609 19.7834 12.1997L11.9524 20.0334C11.8137 20.1721 11.6255 20.25 11.4293 20.25C11.2332 20.25 11.045 20.1721 10.9063 20.0334L1.71645 10.8464Z",
    stroke: "white",
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56995 6.93092C6.18299 6.93092 6.67995 6.43396 6.67995 5.82093C6.67995 5.2079 6.18299 4.71094 5.56995 4.71094C4.95692 4.71094 4.45996 5.2079 4.45996 5.82093C4.45996 6.43396 4.95692 6.93092 5.56995 6.93092Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesActive);
export default __webpack_public_path__ + "static/media/SalesActive.8a2d74404bb79a151d8f7a9cfc8c0853.svg";
export { ForwardRef as ReactComponent };